import {
  Card,
  CardBody,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@apollo/orbit';
import classnames from 'classnames';
import React from 'react';

import { InsightsHistogramTooltip } from 'src/app/graph/insights/InsightsHistogramTooltip';
import { SeriesControls } from 'src/components/charts/helpers/SeriesControls';
import { Histogram } from 'src/components/charts/Histogram';
import { DateRangeBadge } from 'src/components/dateRangeBadge/DateRangeBadge';

import { useServiceReportHistograms } from './ServiceReportHistograms';
import { SubscriptionRegistrationInfoIcon } from './SubscriptionRegistrationInfoIcon';

interface Props {
  isSubscriptionOperation: boolean;
  requestsHistogramStackInfo: ReturnType<
    typeof useServiceReportHistograms
  >['requestsHistogramStackInfo'];
  requestsHistogramData: ReturnType<
    typeof useServiceReportHistograms
  >['requestsHistogramData'];
  onTraceBucketSelect?: (index: number) => void;
}

export function RequestLatencyDistribution({
  isSubscriptionOperation,
  requestsHistogramStackInfo,
  requestsHistogramData,
  onTraceBucketSelect,
}: Props) {
  return (
    <Card
      variant="unstyled"
      className={classnames({ 'mb-10': !isSubscriptionOperation })}
    >
      <CardHeader className="pl-3">
        <CardTitle>
          <span>
            {isSubscriptionOperation
              ? 'Subscription registration latency distribution'
              : 'Request latency distribution'}
          </span>
          {isSubscriptionOperation && <SubscriptionRegistrationInfoIcon />}
          <DateRangeBadge />
        </CardTitle>
        <CardDescription>
          {isSubscriptionOperation
            ? 'The frequency of reported registration request latencies.'
            : 'The frequency of reported request latencies.'}
        </CardDescription>
      </CardHeader>
      <CardBody>
        <Histogram
          stacks={requestsHistogramStackInfo.stacks}
          data={requestsHistogramData}
          onClick={onTraceBucketSelect}
          className="h-36"
          activeSeries={requestsHistogramStackInfo.activeSeries}
          data-testid="requests-histogram"
          tooltipLabelAs={
            <InsightsHistogramTooltip title="Latency distribution" />
          }
          hideCursorArrow
        />
        <SeriesControls
          className="w-full px-4 pt-6 text-center"
          hideWhenSingleStack
          {...requestsHistogramStackInfo}
        />
      </CardBody>
    </Card>
  );
}
